/** Form/API field names for Nectar tracking params forwarded from Orchid to Swarm. */
export const NECTAR_ANONYMOUS_USER_ID_FIELD = 'nectar_anonymous_user_id' as const;
export const NECTAR_IS_PWA_FIELD = 'nectar_is_pwa' as const;
export const NECTAR_PAGE_BLOCK_FIELD = 'nectar_page_block' as const;
export const NECTAR_SITE_ID_FIELD = 'nectar_site_id' as const;

/**
 * URL query-param name for the page block, distinct from the form/API field above.
 * Kept short and unobtrusive so it stays out of the way in user-facing URLs; it is
 * mapped back to NECTAR_PAGE_BLOCK_FIELD before being sent to Swarm.
 */
export const NECTAR_PAGE_BLOCK_GET_PARAM_NAME = '_bhnpb' as const;
